export default "__VITE_ASSET__C_Ui$KAZ__"